/* NJ measurement pilot V1: no personal data; draft theme only */
(function(){
  "use strict";
  function track(name, data){
    var detail=Object.assign({event:name, nj_source:"storefront"},data||{});
    try { document.dispatchEvent(new CustomEvent("nj:analytics",{detail:detail})); }catch(e){}
    // The nj:analytics listener below handles dataLayer exactly once.
  }
  document.addEventListener("nj:analytics",function(e){
    var detail=e.detail;
    if(detail && typeof detail.event==="string" && Array.isArray(window.dataLayer)) window.dataLayer.push(detail);
  });
  document.addEventListener("click",function(e){
    var link=e.target.closest&&e.target.closest("a[href]");
    if(!link)return;
    var href=link.getAttribute("href")||"";
    var card=link.closest("[data-product-id],.product-card,.product-item,.complementary-products,.product-recommendations");
    var placement = link.closest(".nj-cart-rec") ? "cart" : (link.closest(".nj-routine__card") ? "product" : "");
    if(placement && /\/products\//.test(href)){
      track("nj_complement_click",{nj_page:location.pathname,nj_placement:placement,nj_destination:href.split("?")[0]});
    }
    if(/quiz|rutina|recomendador/i.test(href)&&!/^https?:\/\//.test(href)){
      track("nj_quiz_entry_click",{nj_page:location.pathname,nj_destination:href.split("?")[0]});
    }
    if(card&&/\/products\//.test(href)){
      track("nj_product_card_click",{nj_page:location.pathname,nj_destination:href.split("?")[0]});
    }
  },{passive:true});
  // Measure actual on-screen exposure, not just block creation or page loads.
  var impressionObserver = null;
  var observedElements = new WeakSet();
  if(typeof IntersectionObserver === "function"){
    impressionObserver = new IntersectionObserver(function(entries){
      entries.forEach(function(entry){
        if(!entry.isIntersecting)return;
        var node=entry.target;
        if(node.hidden)return;
        var isCart=node.hasAttribute("data-nj-cart-crosssell");
        var count=node.querySelectorAll(isCart ? ".nj-cart-rec" : ".nj-routine__card").length;
        if(!count)return;
        impressionObserver.unobserve(node);
        track("nj_complement_impression",{
          nj_page:location.pathname,
          nj_placement:isCart ? "cart" : "product",
          nj_item_count:count
        });
      });
    },{threshold:0.25});
  }
  var pendingScan=false;
  function scanImpressions(){
    if(!impressionObserver)return;
    document.querySelectorAll("[data-nj-cart-crosssell],[data-nj-pdp-upsell]").forEach(function(node){
      if(node.hidden || observedElements.has(node))return;
      if(!node.querySelector(".nj-cart-rec,.nj-routine__card"))return;
      observedElements.add(node);
      impressionObserver.observe(node);
    });
  }
  function scheduleScan(){
    if(pendingScan)return;
    pendingScan=true;
    window.requestAnimationFrame(function(){
      pendingScan=false;
      scanImpressions();
    });
  }
  function startImpressions(){
    scheduleScan();
    if(typeof MutationObserver === "function" && document.body){
      new MutationObserver(scheduleScan).observe(document.body,{
        childList:true,subtree:true,attributes:true,attributeFilter:["hidden"]
      });
    }
  }
  if(document.readyState==="loading")document.addEventListener("DOMContentLoaded",startImpressions,{once:true});
  else startImpressions();
})();